var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseMessageInfoDetails(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "open_ic",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.001,
    height: 24.001,
    viewBox: "0 0 24.001 24.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_9649",
    "data-name": "Path 9649",
    d: "M12,0A12,12,0,1,1,0,12,12,12,0,0,1,12,0Z",
    transform: "translate(0 0)",
    fill: "#efefef"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "minus_ic",
    transform: "translate(7.68 11.521)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_786",
    "data-name": "Group 786",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1811",
    "data-name": "Path 1811",
    d: "M9.006,211.613H.517a.685.685,0,0,0,0,1.329H9.006a.685.685,0,0,0,0-1.329Z",
    transform: "translate(0 -211.613)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseMessageInfoDetails);
export default __webpack_public_path__ + "static/media/closeMessageInfoDetails.9d0b9d5efcb068ecf11a4c4483a33b6c.svg";
export { ForwardRef as ReactComponent };